/**
 * Basic entity definition for generic entity widgets.
 */
class EntityConfig {
    constructor() {
        this.icon = '';
        this.title = '';
        this.eyebrow = '';
        this.subtitle = '';
        this.badgeText = '';
        this.badgeStyle = '';
    }
    setIcon(icon) {
        this.icon = icon;
        return this;
    }
    setTitle(title) {
        this.title = title;
        return this;
    }
    setEyebrow(eyebrow) {
        this.eyebrow = eyebrow;
        return this;
    }
    setSubtitle(subtitle) {
        this.subtitle = subtitle;
        return this;
    }
    setBadge(text, style = '') {
        this.badgeText = text;
        this.badgeStyle = style;
        return this;
    }
}
export { EntityConfig };
//# sourceMappingURL=EntityConfig.js.map